import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, object } from "yup";
import { number } from "../Utils/schemaUtils";

export type StateAidCalculationFormType = {
  readonly basicAmount: number;
  readonly assessmentBase: number;
  readonly percentageAmount: number;
};

export const stateAidCalculationFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<StateAidCalculationFormType> = (t) => {
  return object({
    basicAmount: number().required(t(Resources.Validation.Required)),
    assessmentBase: number().required(t(Resources.Validation.Required)),
    percentageAmount: number().required(t(Resources.Validation.Required)),
  }).defined();
};
